module.exports = __webpack_public_path__ + "static/media/fallback_teaser.0bfaff3f.png";